import { Container, IDestroyOptions, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../../common/GameFont";
import { BuildingDescriptionContainer } from "./BuildingDescriptionContainer";
import { CommonResourcesPackage } from "../../../../../common/resources/CommonResourcesPackage";
import { IMarketplaceBuildingModel } from "../../models/building/IMarketplaceBuildingModel";
import { nameof } from "bindable-data";

export class FullBuildingInfoContainer extends Container {
    private readonly commonResources: CommonResourcesPackage;
    private readonly marketplaceBuildingModel: IMarketplaceBuildingModel;

    private address: Text;
    private additionalAddress: Text;
    private buildingDescriptionContainer: BuildingDescriptionContainer;

    public constructor(
        commonResources: CommonResourcesPackage,
        marketplaceBuildingModel: IMarketplaceBuildingModel,
    ) {
        super();
        this.commonResources = commonResources;
        this.marketplaceBuildingModel = marketplaceBuildingModel;
        this.marketplaceBuildingModel.propertyChanged.add(this.onMarketplaceBuildingModelPropertyChanged, this);
        this.build();
    }

    private async onMarketplaceBuildingModelPropertyChanged(model: IMarketplaceBuildingModel, key: string): Promise<void> {
        switch (key) {
            case nameof(model, "currentBuilding"):
                const currentBuilding = model.currentBuilding.value.building;
                this.address.text = currentBuilding.address;
                this.additionalAddress.text = `${currentBuilding.zipCode}, ${currentBuilding.city}, ${currentBuilding.borough.toUpperCase()}`
                break;
        }
    }

    private build(): void {
        this.address = new Text("1799 LEXINGTON AVE", new AddressTextStyle());
        this.address.anchor.set(0.5);

        this.additionalAddress = new Text("10010, NYC, MANHATTAN", new AdditionalAddressTextStyle());
        this.additionalAddress.position.y = this.address.y + this.address.height * 0.5 + this.additionalAddress.height * 0.5 + 15;
        this.additionalAddress.anchor.set(0.5);

        this.buildingDescriptionContainer = new BuildingDescriptionContainer(this.commonResources, this.marketplaceBuildingModel);
        this.buildingDescriptionContainer.y = 117;
        this.buildingDescriptionContainer.pivot.x = this.buildingDescriptionContainer.width * 0.5;
        this.addChild(this.address, this.additionalAddress, this.buildingDescriptionContainer);
    }

    public showInfoContainer(tokensValue: string): void {
        this.buildingDescriptionContainer.scale.set(1);
        if (tokensValue != null) {
            const tokenFieldWidth = this.buildingDescriptionContainer.showWithToken(Number(tokensValue));
            this.buildingDescriptionContainer.pivot.x = this.buildingDescriptionContainer.width * 0.5 - tokenFieldWidth;
            this.buildingDescriptionContainer.scale.set(0.86);
            return;
        }
        this.buildingDescriptionContainer.pivot.x = this.buildingDescriptionContainer.width * 0.5;
    }

    public hideContainer(): void {
        this.buildingDescriptionContainer.hideContainer();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.marketplaceBuildingModel.propertyChanged.remove(this.onMarketplaceBuildingModelPropertyChanged, this);
        super.destroy(options);
    }
}

class AddressTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72
        }));
    }
}

class AdditionalAddressTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#b9b2cc",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 37
        }));
    }
}
